__turbopack_context__.v({
  "chip": "RIA4LG_chip",
});
